class productHelper {
    constructor() {
        this.scrolltoURL();

    }
    bindHomeFeaturedProducts(el) {
        var productToggles = $(el).find('[data-product-toggle]');

        $(productToggles).each((index,toggle) => {
            $(toggle).click((e) => {
                var url = $(toggle).data('url');
                if (window.innerWidth < 992) {
                    // Navigate to product page on click
                    window.location = window.location.origin + url;
                } else {
                    if ( $(toggle).hasClass('active') ) {
                        window.location = window.location.origin + url;
                    } else {
                        var active = $(toggle).data('productToggle');
                        $(productToggles).removeClass('active');
                        $('[data-product-toggle="'+active+'"]').addClass('active');
                    }
                }
            });
        });
    }
    initBazaarVoiceInlineRating() {
        var IDs = [];
        $('[data-product]').each(function() {
            if ($(this).data('product') != '' && IDs.indexOf($(this).data('product')) < 0) IDs.push($(this).data('product'));
        });
        if (IDs.length > 0) {
            $BV.ui( 'rr', 'inline_ratings', {
                productIds: IDs,
                containerPrefix: 'BazaarVoiceInlineRating',
            });
            this.bvCSSFix();
        }
    }
    bazaarVoiceInlineRating(el) {
        var IDs = [], containerPrefix = $(el).data('containerPrefix'), products = $(el).find('[data-product]');
        $(products).each(function(){
            if ($(this).data('product') != '') IDs.push($(this).data('product'));
        });
        if (IDs.length > 0) {
            $BV.ui( 'rr', 'inline_ratings', {
                productIds: IDs,
                containerPrefix: containerPrefix
            });
            window.app.product.bvCSSFix();
        }
    }   
    initBazaarVoiceWriteReview(el) {
        var productID = $(el).data('product');
        if (productID != null) {
            $(el).click((e) => {
                e.preventDefault();
                $BV.ui('rr', 'submit_review', { productId : productID });
            });
        }
    }
    initBazaarVoiceWriteReviewCategory(el) {
        var categoryId = $(el).data('category');
        // var productID = $(el).data('product');
        // console.log('Review on click bound for product with upc: ' + productID);
        if (categoryId != null) {
            
            $(el).click((e) => {
                e.preventDefault();
                $BV.ui('rr', 'submit_generic', { categoryId: categoryId });
            });
            
        }
    }
    initReviewsContainer(el) {
        var productID = $(el).data('product');
        $BV.configure('global', { productId : ''+productID+'' });
        $BV.ui( 'rr', 'show_reviews', {
            doShowContent : function () { 
               // If the container is hidden (such as behind a tab), put code here to make it visible 
               //(open the tab).
            }
        });
    }
    bvCSSFix() {
        $('.bv-rating-ratio').each(function() {
            console.log(this);
            $(this).css('display', 'inline !important');
        });
    }
    scrolltoURL() {
        console.log('scroll');
        var hash = window.location.hash;
        var target = $(hash);
        if (target.length) {
            if (hash != '#product-content') {
                var dest = target.offset().top - 300;
            } else {
                var dest = target.offset().top;
            }
            $("html, body").animate({ scrollTop: dest }, 1500);

        }
        
    }
    createCookie(name, value, days) {
        var expires;

        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        } else {
            expires = "";
        }
        document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
    }

    readCookie(name) {
        var nameEQ = encodeURIComponent(name) + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    }
    stickyCTA() {
        var cta = $('.sticky-cta');
        if(!app.product.readCookie('hide_message')){
            console.log(cta);
          cta.show();
        }
		$('#consentOk').on('click', () => {
            cta.hide();
            app.product.createCookie('hide_message', true, 45);
        });
	}
}
window.app.add('product', new productHelper());


// WEBPACK FOOTER //
// ./_src/js/lib/product.js